import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { DataDisplay, DisplayRow, } from "../../../../../../components/common/DataDisplay/DataDisplay";
function UserDetails({ user }) {
    if (!user) {
        return null;
    }
    const rowClasses = "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-mb-4 wpqt-gap-1 wpqt-text-xl";
    return (_jsx("div", { className: "wpqt-mb-4", children: _jsxs(DataDisplay, { children: [_jsx(DisplayRow, { label: __("Name", "quicktasker"), className: rowClasses, children: user.name }), user.description && (_jsx(DisplayRow, { label: __("Description", "quicktasker"), className: rowClasses, children: user.description })), _jsx(DisplayRow, { label: __("Assigned tasks count", "quicktasker"), className: rowClasses, children: user.assigned_tasks_count })] }) }));
}
export { UserDetails };
